import { format, parseISO } from 'date-fns';

import { addTimeToDate, getRelativeDate, isIsoDateString } from '@utils/date';

import { newDateIgnoreLocalTimezone } from '../timezone';

type ScheduledDateInput = {
  referenceDate?: string | null;
  comparator: 'lt' | 'gt' | '';
  days: number;
  time: string;
  savedDate?: string | null;
};

const TIMEZONE_DESIGNATOR_PATTERN = /(Z|[+-]\d{2}(:?\d{2})?)$/i;

const toCalendarDate = (referenceDate: string): string => {
  const parsed = parseISO(referenceDate);
  if (TIMEZONE_DESIGNATOR_PATTERN.test(referenceDate)) {
    return parsed.toISOString().slice(0, 10);
  }
  return format(parsed, 'yyyy-MM-dd');
};

export const getScheduledDate = ({
  referenceDate,
  comparator,
  days,
  time,
  savedDate,
}: ScheduledDateInput): Date | null => {
  if (isIsoDateString(referenceDate)) {
    const calendarDate = toCalendarDate(referenceDate);
    const relativeReferenceDate = getRelativeDate(calendarDate, comparator, days);
    return newDateIgnoreLocalTimezone(addTimeToDate(relativeReferenceDate, time));
  }
  if (savedDate) {
    return newDateIgnoreLocalTimezone(savedDate);
  }
  return null;
};
